import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { IStoreState } from '../../types/index'

export interface IModalProps {
  children: JSX.Element
}

const ModalLayout = ({ children }: { children: JSX.Element }) => {
  return (
    <div className='Modal'>
      <div className='overlay bg-dark-grey' />
      <div className='content-container'>{children}</div>
    </div>
  )
}

class Modal extends React.Component<IModalProps, IStoreState> {
  private el: HTMLElement
  private container: HTMLElement

  constructor(props: IModalProps) {
    super(props)
    this.el = document.createElement('div')
  }

  public componentDidMount() {
    this.container = document.getElementById('modal-container') as HTMLElement
    this.container.appendChild(this.el)
  }

  public componentWillUnmount() {
    this.container.removeChild(this.el)
  }

  public render() {
    // ReactDOM.createPortal doesn't work with typescript for some reason
    return ReactDOM.createPortal(<ModalLayout {...this.props} />, this.el)
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/ui/Modal.tsx